import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";

const AdminPage = lazy(() =>
  import("./modules/Admin/pages/AdminPage")
);

export default function BasePageAdmin() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /admin */
          <Redirect exact from="/" to="/admin" />
        }
        <Route path="/admin" component={AdminPage} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
